import { ACTIONS } from "./actionTypes";

const initialState = {
  campaigns: [],
  loading: true,
  error: "",
  id: "",
  bootstrap_retargeting_campaign_kind: null,
  errorPostCampaigns: "",
  errorCreateList: "",
  list: null,
  editCampaign: null,
};

export const createNewCompanyReducer = (state = initialState, action) => {
  const { type, payload } = action;
  switch (type) {
    case ACTIONS.CREATE_NEW_COMPANY_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case ACTIONS.SET_EDIT_CAMPAIGN:
      return {
        ...state,
        id: payload,
        bootstrap_retargeting_campaign_kind: null,
        editCampaign: state.campaigns.find(
          (campaign) => campaign.id === payload
        ),
      };
    case ACTIONS.RESET_EDIT_CAMPAIGN:
      return {
        ...state,
        id: "",
        editCampaign: null,
        bootstrap_retargeting_campaign_kind: null,
      };
    case ACTIONS.CREATE_NEW_COMPANY_SUCCESS:
      return {
        ...state,
        loading: false,
        id: typeof payload === "object" ? payload.id : payload,
        bootstrap_retargeting_campaign_kind:
          typeof payload === "object"
            ? payload.retargeting_campaign_kind ?? null
            : null,
      };
    case ACTIONS.CREATE_NEW_COMPANY_FAILURE:
      return {
        ...state,
        loading: false,
        errorPostCampaigns: payload,
      };
    case ACTIONS.GET_CAMPAIGNS_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case ACTIONS.GET_CAMPAIGNS_SUCCESS: {
      const nextEdit =
        state.id
          ? payload.find((campaign) => campaign.id === state.id)
          : null;
      return {
        ...state,
        loading: false,
        campaigns: payload,
        error: "",
        editCampaign: nextEdit,
        bootstrap_retargeting_campaign_kind: nextEdit
          ? null
          : state.bootstrap_retargeting_campaign_kind,
      };
    }
    case ACTIONS.GET_CAMPAIGNS_FAILURE:
      return {
        ...state,
        loading: false,
        campaigns: [],
        error: payload,
      };
    case ACTIONS.UPDATE_CAMPAIGN_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case ACTIONS.UPDATE_CAMPAIGN_SUCCESS:
      return {
        ...state,
        loading: false,
      };
    case ACTIONS.UPDATE_CAMPAIGN_FAILURE:
      return {
        ...state,
        loading: false,
        errorPostCampaigns: payload,
      };
    case ACTIONS.CREATE_LIST_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case ACTIONS.CREATE_LIST_SUCCESS:
      return {
        ...state,
        loading: false,
        list: payload,
      };
    case ACTIONS.CREATE_LIST_FAILURE:
      return {
        ...state,
        loading: false,
        errorCreateList: payload,
      };
    default:
      return state;
  }
};
